// extracted by mini-css-extract-plugin
export default {"Paragraph":"Paragraph_Paragraph__hGqAi","bright":"Paragraph_bright__t9cvn"};